import React from 'react';
import Box from 'js/components/box/box';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './banner.module.scss';
import Row from '../grid/row';
import Col from '../grid/column';

function Banner({ color, children }) {
    const classes = [styles['banner-container']];
    if (color) {
        classes.push(styles[`background--${color[0]}-${color[1]}`]);
    }

    return (
        <div className={classNames(classes)}>
            <Box padding={['base']}>
                <Row justifyContent="center">
                    <Col span="auto">{children}</Col>
                </Row>
            </Box>
        </div>
    );
}

const colors = [
    'purple',
    'red',
    'yellow',
    'aqua',
    'gray',
    'blue',
    'black',
    'pink',
    'darkest',
    'darker',
    'dark',
    'base',
    'light',
    'lighter',
    'lightest',
    'background',
    'white',
];

Banner.defaultProps = {
    color: ['blue', 'dark'],
};

Banner.propTypes = {
    color: PropTypes.arrayOf(PropTypes.oneOf(colors)),
    children: PropTypes.node.isRequired,
};

export default Banner;
